import { render } from "./WhatToExpect.vue?vue&type=template&id=b7477ddc&scoped=true"
import script from "./WhatToExpect.vue?vue&type=script&lang=js"
export * from "./WhatToExpect.vue?vue&type=script&lang=js"

import "./WhatToExpect.vue?vue&type=style&index=0&id=b7477ddc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b7477ddc"]])

export default __exports__